import React from 'react'
import DashboardMetricItem from '@components/pages/Dashboard/DashboardMetricItem.component'
import DashboardSectionEmptyState from '@components/pages/Dashboard/DashboardSectionEmptyState.component'
import DashboardHalfDonutChart from '@components/pages/Dashboard/MetricCharts/DashboardHalfDonutChart.component'
import { metricDataToItemPropsWithLayoutClass } from '@utils/dashboardMetrics.util'
import type { DashboardMetricItemData } from '../../../../types/dashboardMetrics.types'

export type OverviewSectionLegendItem = {
  label: string
  color: string
}

export type OverviewSectionChartConfig = {
  title: string
  primaryValue: number
  secondaryValue: number
  valueFormatter: (v: number) => string
  slices?: Array<{ name: string; value: number; color: string }>
}

type OverviewMetricSectionCardContentProps = {
  topMetrics: DashboardMetricItemData[]
  highlight: {
    leftLabel: string
    value: React.ReactNode
  }
  chart: OverviewSectionChartConfig
  legend: OverviewSectionLegendItem[]
  isChartEmpty?: boolean
}

function OverviewMetricSectionCardContent({
  topMetrics,
  highlight,
  chart,
  legend,
  isChartEmpty = false,
}: OverviewMetricSectionCardContentProps): React.ReactElement {
  return (
    <div className="dashboard-overview-acceptance-content">
      <div className="dashboard-overview-acceptance-metrics-row">
        {topMetrics.map((m) => (
          <DashboardMetricItem
            key={m.id ?? m.leftLabel}
            {...metricDataToItemPropsWithLayoutClass(
              m,
              'dashboard-overview-acceptance-metric',
            )}
          />
        ))}
      </div>
      <DashboardMetricItem
        className="dashboard-overview-acceptance-metric dashboard-overview-acceptance-metric--full"
        leftLabel={highlight.leftLabel}
        value={highlight.value}
      />
      {isChartEmpty ? (
        <DashboardSectionEmptyState className="dashboard-section-empty--embed" />
      ) : (
        <div className="dashboard-overview-acceptance-chart-box">
          <DashboardHalfDonutChart
            title={chart.title}
            primaryValue={chart.primaryValue}
            secondaryValue={chart.secondaryValue}
            valueFormatter={chart.valueFormatter}
            slices={chart.slices}
            hideCenterMetric
            className="dashboard-overview-acceptance-chart"
          />
          <div className="dashboard-overview-acceptance-legend">
            {legend.map((item) => (
              <span
                key={item.label}
                className="dashboard-overview-acceptance-legend-item"
              >
                <span
                  className="dashboard-overview-acceptance-legend-dot"
                  style={{ background: item.color }}
                />
                {item.label}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default OverviewMetricSectionCardContent
